import { render, staticRenderFns } from "./FormatReferenceTreeEditor.vue?vue&type=template&id=aa77bbfa&scoped=true&"
import script from "./FormatReferenceTreeEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceTreeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceTreeEditor.vue?vue&type=style&index=0&id=aa77bbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa77bbfa",
  null
  
)

export default component.exports